<template>
  <div>
    <div>
      <!-- Register v1 -->
      <b-card
        class="mb-0"
        title=""
      >
        <!-- form -->
        <validation-observer
          ref="createpaymentForm"
          #default="{ invalid }"
        >
          <b-form @submit.prevent="createPayment">
            <!-- Batch-->

            <b-col cols="12">
              <b-form-group
                label="Batch"
                label-for="batch"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Batch"
                  vid="batch"
                  rules="required"
                >
                  <v-select
                    id="batch"
                    v-model="form.batch"
                    placeholder="Select the Batch"
                    :options="batch"
                    :reduce="(option) => option.value"
                    label="label"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- Intake-->

            <b-col cols="12">
              <b-form-group
                label="Intake"
                label-for="intake"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Intake"
                  vid="intake"
                  rules="required"
                >
                  <v-select
                    id="intake"
                    v-model="form.intake"
                    placeholder="Select the Intake"
                    :options="intake"
                    :reduce="(option) => option.value"
                    label="label"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- get users to the respective Batch & Intake-->
            <b-col cols="12">
              <b-form-group
                label="User"
                label-for="user"
              >
                <validation-provider
                  #default="{ errors }"
                  name="User"
                  vid="user"
                  rules="required"
                >
                  <v-select
                    id="status"
                    v-model="selected1"
                    :options="filteredUsers"
                    label="name"
                    :disabled="!form.batch || !form.intake"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- Enable Flex Payment-->

            <b-col cols="12">
              <b-form-group
                label="Enable Flex Payment"
                label-for="batch"
              >
                <validation-provider
                  #default="{ errors }"
                  name="flexpmt"
                  vid="flexpmt"
                  rules="required"
                >
                  <v-select
                    id="flexpmt"
                    v-model="form.flexpmt"
                    placeholder="Select Regular Flex Payment required"
                    :options="flexpmt"
                    :reduce="(option) => option.value"
                    label="label"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Flex Payment Datepicker | Only if Flex payment selected -->
            <b-col cols="12">
              <b-form-group
                label="Flex Payment Date"
                label-for="flex_payment_date"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Flex Payment Date"
                  vid="flex_payment_date"
                  :rules="
                    form.flexpmt === 'fpmt' || form.flexpmt === 'date_only'
                      ? 'required'
                      : ''
                  "
                >
                  <b-form-datepicker
                    id="due_date"
                    v-model="form.due_date"
                    placeholder="Select Flex Payment Date"
                    :disabled="
                      form.flexpmt !== 'fpmt' && form.flexpmt !== 'date_only'
                    "
                  />
                  <!-- Activate only when Flexpayment selected -->
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- amount -->
            <b-col cols="12">
              <b-form-group
                label="Paid Amount"
                label-for="meetingid"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Paid Amount"
                  vid="paid_amount"
                  :rules="
                    form.flexpmt === 'date_only' ? '' : 'required|integer'
                  "
                >
                  <b-form-input
                    id="register-meetingid"
                    v-model="form.amount"
                    step="2"
                    name="register-paidmonthid"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Enter Amount"
                    :readonly="form.flexpmt === 'rpmt'"
                    :disabled="form.flexpmt === 'date_only'"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- current month number -->

            <b-form-group
              label="Paid Month"
              label-for="paid_month"
            >
              <validation-provider
                #default="{ errors }"
                name="Paid Month"
                vid="Paid Month"
                :rules="form.flexpmt === 'date_only' ? '' : 'required|integer'"
              >
                <v-select
                  id="Select Current Month"
                  v-model="form.paid_month"
                  :options="paidMonthOptions"
                  label="label"
                  :disabled="form.flexpmt === 'date_only'"
                  :reduce="(option) => option.value"
                  :class="{ 'is-invalid': errors.length > 0 }"
                  placeholder="Select Paid Month"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- Payment Date -->
            <b-col cols="12">
              <b-form-group
                label="Payment Date"
                label-for="paymentdate"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Payment Date"
                  vid="Payment Date"
                  :rules="form.flexpmt === 'date_only' ? '' : 'required'"
                >
                  <b-form-datepicker
                    v-model="form.payment_date"
                    name="register-payment_date"
                    :disabled="form.flexpmt === 'date_only'"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- Button -->

            <b-button
              variant="primary"
              block
              type="submit"
              :disabled="invalid"
            >
              Submit
            </b-button>
          </b-form>
        </validation-observer>
      </b-card>
      <!-- /Register v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import paymentApi from '@/Api/Modules/payment'
import usersApi from '@/Api/Modules/auth'
import {
  BCard,
  BLink,
  BCardTitle,
  BCardText,
  BForm,
  BButton,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BFormDatepicker,
  BImg,
  BInputGroupAppend,
} from 'bootstrap-vue'
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from '@validations'

export default {
  name: 'Register',
  components: {
    vSelect,
    BCard,
    BFormDatepicker,
    BCardTitle,
    BImg,
    BCardText,
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,

    // validations
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      installmentDue: 0,
      isSubmitting: false,
      form: {
        batch: null,
        intake: null,
        amount: null,
        payment_date: null,
        user_id: null,
        paid_month: null,
        due_date: null,
        flexpmt: null,
      },

      batch: [
        { label: 'B03', value: 'B03' },
        { label: 'B04', value: 'B04' },
        { label: 'B05', value: 'B05' },
        { label: 'B06', value: 'B06' },
        { label: 'B07', value: 'B07' },
      ],

      intake: [
        { label: '01', value: '01' },
        { label: '02', value: '02' },
      ],
      selected1: {
        name: 'Select User',
      },
      options1: [],
      months: [
        { label: '01', value: 1 },
        { label: '02', value: 2 },
        { label: '03', value: 3 },
        { label: '04', value: 4 },
        { label: '05', value: 5 },
        { label: '06', value: 6 },
      ],

      // Select payment Type
      flexpmt: [
        { label: 'Enable Flex Payment', value: 'fpmt' },
        { label: 'Regular Payment', value: 'rpmt' },
        { label: 'Payment Date Only Change', value: 'date_only' },
      ],

      // validation rules
      required,
      email,
      confirmed,
      url,
      between,
      alpha,
      integer,
      password,
      min,
      digits,
      alphaDash,
      length,
    }
  },
  computed: {
    paidMonthOptions() {
      if (this.selected1?.payment_type !== 'Instalment Payment') {
        return this.months
      }

      const installmentPlan = Number(this.selected1.installment_plan) === 6 ? 6 : 4
      return this.months.slice(0, installmentPlan)
    },
    filteredUsers() {
      const selectedBatch = this.form.batch ? String(this.form.batch) : null
      const selectedIntake = this.form.intake ? String(this.form.intake) : null

      console.log(
        'Filtering users for batch =',
        selectedBatch,
        'intake =',
        selectedIntake,
      )

      return this.options1.filter(user => {
        const userBatch = user.batch ? String(user.batch) : null
        const userIntake = user.intake ? String(user.intake) : null

        console.log(
          `Checking user: ${user.name}, user.batch=${userBatch}, user.intake=${userIntake}`,
        )

        const batchMatch = selectedBatch ? userBatch === selectedBatch : true
        const intakeMatch = selectedIntake
          ? userIntake === selectedIntake
          : true

        return batchMatch && intakeMatch
      })
    },
  },
  watch: {
    async selected1(newUser) {
      if (!newUser) return

      this.installmentDue = null
      if (this.form.paid_month && !this.paidMonthOptions.some(month => month.value === Number(this.form.paid_month))) {
        this.form.paid_month = null
      }

      // Flex payment logic (already existing)
      if (newUser.due_date) {
        this.form.flexpmt = 'fpmt'
        this.form.due_date = newUser.due_date
      } else {
        this.form.flexpmt = 'rpmt'
        this.form.due_date = null
      }

      // 🔥 NEW: load due_total and set Paid Amount
      try {
        const res = await paymentApi.allPayments({
          user_id: newUser.id,
        })

        const dueTotal = res.data?.data?.installment_due ?? 0
        this.installmentDue = dueTotal

        // Auto-fill Paid Amount
        this.form.amount = dueTotal
      } catch (error) {
        console.error('Failed to load due_total', error)
        this.form.amount = null
      }
    },

    'form.flexpmt': function (newVal) {
      if (newVal === 'date_only') {
        this.form.amount = 0
        this.form.paid_month = null
        this.form.payment_date = null
      } else if (newVal === 'rpmt') {
        this.form.amount = this.installmentDue
      }
    },
  },
  async created() {
    await this.Users()
  },

  methods: {
    showToastError(msg) {
      const safeMessage = typeof msg === 'string' && msg.trim().length > 0
        ? msg
        : 'Payment failed. Please check your input.'

      this.$toast.error(safeMessage)
    },

    async Users() {
      await this.$vs.loading({
        scale: 0.8,
      })

      const res = await usersApi.allUsers()

      const paymentPayload = {
        user_id: this.form.user_id,
        amount: this.form.amount,
        payment_date: this.form.payment_date,
        paid_month: this.form.paid_month,
        flexpmt: this.form.flexpmt,
      }

      const userPayload = {
        id: this.form.user_id,
        due_date: this.form.due_date,
      }

      console.log('All users from API:', res.data.data)
      this.options1 = res.data.data

      if (this.options1.length === 0) {
        this.selected1.name = 'Select User'
      }

      this.$vs.loading.close()
    },

    async createPayment() {
      if (!this.selected1 || !this.selected1.id) {
        this.showToastError('Please select a user')
        return
      }

      this.form.user_id = this.selected1.id
      this.form.amount = Number(this.form.amount)

      const isValid = await this.$refs.createpaymentForm.validate()
      if (!isValid) return

      await this.$vs.loading({ scale: 0.8 })

      // ✅ Decide due_date BEFORE submitting

      const paidAmount = Number(this.form.amount)
      const dueAmount = Number(this.installmentDue)

      console.log('DEBUG → paidAmount:', paidAmount)
      console.log('DEBUG → installmentDue:', this.installmentDue)
      console.log('DEBUG → dueAmount:', dueAmount)

      const shouldClearDueDate = paidAmount === dueAmount && paidAmount !== 0

      if (shouldClearDueDate) {
        this.form.due_date = null

        console.log('DEBUG → current due date:', this.form.due_date)
      }

      try {
        console.log('🔥 ENTERED createPayment')

        // 🟡 CASE: date_only → update due_date ONLY

        console.log('Sending due_date:', this.form.due_date)
        if (this.form.flexpmt === 'date_only') {
          await usersApi.updateDueDate({
            id: this.form.user_id,
            due_date: this.form.due_date,
          })

          this.$vs.loading.close()
          this.$toast.success('Due date updated successfully')
          return // ⛔ STOP — no payment
        }

        // 🟢 CASE: rpmt / fpmt → create payment
        await paymentApi.createPayment({
          user_id: this.form.user_id,
          amount: this.form.amount,
          paid_month: this.form.paid_month,
          payment_date: this.form.payment_date,
          flexpmt: this.form.flexpmt,
        })

        // 🔵 Update due_date ONLY when required
        if (this.form.flexpmt === 'fpmt' || shouldClearDueDate) {
          await usersApi.updateDueDate({
            id: this.form.user_id,
            due_date: this.form.due_date, // null if full payment
          })
        }

        this.$vs.loading.close()
        this.$toast.success('Payment created successfully')
      } catch (error) {
        this.$vs.loading.close()

        // Network error
        if (!error.response) {
          this.showToastError('Network error. Please try again.')
          return
        }

        console.log('FULL ERROR:', error)
        // Laravel validation errors (422)
        if (
          error.response
          && error.response.data
          && error.response.data.errors
        ) {
          const { errors } = error.response.data
          const firstKey = Object.keys(errors)[0]
          const message = errors[firstKey]?.[0]

          this.showToastError(message)
          return
        }

        // Custom backend error message
        if (error.response && typeof error.response.data?.error === 'string') {
          this.showToastError(error.response.data.error)
          return
        }

        // Network / unknown error
        this.showToastError()
      }
    },
  },
}
</script>
